/* eslint no-script-url: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import Anchor from '../../Anchor';

/**
 * Metronic's brand display and side menu toggler
 */
export default function Brand({ theme, logo }) {
  return (
    <div className="m-stack__item m-brand academy-brand">
      <div className="m-stack m-stack--ver m-stack--general">
        <div className="m-stack__item m-stack__item--middle m-brand__logo">
          <Anchor href="/" className="m-brand__logo-wrapper">
            <img
              alt="brand logo"
              src={
                logo ||
                `/dist/${theme}/assets/demo/${theme}/media/img/logo/logo-dark.png`
              }
            />
          </Anchor>
        </div>
        <div className="m-stack__item m-stack__item--middle m-brand__tools">
          {/*
          <Anchor
            style={{ cursor: 'pointer' }}
            id="m_aside_left_offcanvas_toggle"
            className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block"
          >
            <span />
          </Anchor>
          */}
          <a
            style={{ cursor: 'pointer' }}
            id="m_aside_header_menu_mobile_toggle"
            className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block"
          >
            <span />
          </a>
          <a
            id="m_aside_header_topbar_mobile_toggle"
            style={{ cursor: 'pointer' }}
            className="m-brand__icon m--visible-tablet-and-mobile-inline-block"
          >
            <i className="flaticon-user" />
          </a>
        </div>
      </div>
    </div>
  );
}

Brand.propTypes = {
  /** metronic theme in use */
  theme: PropTypes.string.isRequired,
  logo: PropTypes.string,
};

Brand.defaultProps = {
  logo: null,
};
